var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridViewPressed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#0679CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11.25H9.75C10.575 11.25 11.25 10.575 11.25 9.75V6.75C11.25 5.925 10.575 5.25 9.75 5.25H6.75C5.925 5.25 5.25 5.925 5.25 6.75V9.75C5.25 10.575 5.925 11.25 6.75 11.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 18.75H9.75C10.575 18.75 11.25 18.075 11.25 17.25V14.25C11.25 13.425 10.575 12.75 9.75 12.75H6.75C5.925 12.75 5.25 13.425 5.25 14.25V17.25C5.25 18.075 5.925 18.75 6.75 18.75Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 6.75V9.75C12.75 10.575 13.425 11.25 14.25 11.25H17.25C18.075 11.25 18.75 10.575 18.75 9.75V6.75C18.75 5.925 18.075 5.25 17.25 5.25H14.25C13.425 5.25 12.75 5.925 12.75 6.75Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 18.75H17.25C18.075 18.75 18.75 18.075 18.75 17.25V14.25C18.75 13.425 18.075 12.75 17.25 12.75H14.25C13.425 12.75 12.75 13.425 12.75 14.25V17.25C12.75 18.075 13.425 18.75 14.25 18.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridViewPressed);
export default __webpack_public_path__ + "static/media/grid-view-pressed.0fc8432a546af43246dd8805239c68aa.svg";
export { ForwardRef as ReactComponent };